module.exports = __webpack_public_path__ + "img/nodata.1d10f376.svg";